import type { Achievement, Milestone } from '../types'

export const achievements: Achievement[] = [
  {
    period: '2015 — 2023',
    role: 'Governor, Osun State',
    challenge:
      'Eleven months of unpaid salaries, a collapsing internally generated revenue base and 41% of schools without usable classrooms.',
    action:
      'Rebuilt the revenue service, renegotiated state debt and ring-fenced education spending at 26% of the budget.',
    outcome:
      'IGR grew 4.1x, salaries paid on or before the 25th for 84 consecutive months, and 1,240 classrooms rebuilt.',
    source: 'Osun State Accountant-General Report, 2023',
  },
  {
    period: '2011 — 2015',
    role: 'Managing Director, Nigerian Industrial Development Bank',
    challenge:
      'A development finance institution lending at scale but recovering less than half of what it disbursed.',
    action:
      'Introduced independent credit review, published the full loan book and tied executive pay to recovery rates.',
    outcome:
      'Non-performing loans fell from 38% to 9%, unlocking ₦180bn in new lending to manufacturers.',
    source: 'NIDB Annual Report, 2015',
  },
  {
    period: '2003 — 2011',
    role: 'Founder, Bello Agro-Industries',
    challenge:
      'Nigerian cassava farmers losing up to 40% of harvest before it reached any market.',
    action:
      'Built four regional processing plants and an out-grower scheme with guaranteed offtake pricing.',
    outcome:
      '22,000 smallholder farmers under contract and post-harvest losses cut to under 8% across the network.',
    source: 'Independent impact audit, Dalberg 2012',
  },
]

export const milestones: Milestone[] = [
  {
    marker: 'Day One',
    title: 'Signal the direction',
    description:
      'Executive orders that cost nothing but change everything about how the government behaves.',
    priorities: [
      'Publish all federal contracts above ₦100m',
      'Freeze new government vehicle purchases',
      'Convene the National Security Council',
    ],
  },
  {
    marker: 'First 30 Days',
    title: 'Stabilise the essentials',
    description:
      'Move quickly on the two things households feel first: safety and the cost of living.',
    priorities: [
      'Emergency plan for the highway corridors',
      'Fuel and food logistics task force',
      'Ministerial performance contracts signed',
    ],
  },
  {
    marker: 'First 60 Days',
    title: 'Fix the delivery machine',
    description:
      'Rebuild the institutions that must execute everything else in the agenda.',
    priorities: [
      'Power sector reform bill to the Assembly',
      'National teacher payroll audit',
      'Open-contracting portal live',
    ],
  },
  {
    marker: 'First 100 Days',
    title: 'Report to Nigerians',
    description:
      'A published, independently verified scorecard — and the four-year targets that follow from it.',
    priorities: [
      'First 100 Days national broadcast',
      '2028 budget framework released early',
      'State-by-state delivery compacts signed',
    ],
  },
]
